// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bento Grid Proof of Reserves CSS */

/* Base container with dynamic grid background */
.por-page-container {
  background-color: #030712;
  color: #f8fafc;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  font-family: 'Inter', 'Outfit', sans-serif;
  z-index: 1;
}

/* Premium mesh grid pattern overlay */
.por-mesh-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(rgba(99, 102, 241, 0.05) 1px, transparent 1px),
    radial-gradient(rgba(245, 158, 11, 0.03) 1px, transparent 1px);
  background-size: 40px 40px;
  background-position: 0 0, 20px 20px;
  opacity: 0.8;
  z-index: 0;
  pointer-events: none;
}

/* Ambient glow lights */
.por-radial-spot {
  position: absolute;
  width: 600px;
  height: 600px;
  border-radius: 50%;
  filter: blur(140px);
  pointer-events: none;
  opacity: 0.12;
  z-index: 0;
}

.por-spot-indigo {
  background: radial-gradient(circle, #6366f1 0%, rgba(99, 102, 241, 0) 70%);
  top: -150px;
  right: -50px;
}

.por-spot-amber {
  background: radial-gradient(circle, #f59e0b 0%, rgba(245, 158, 11, 0) 70%);
  bottom: 5%;
  left: -200px;
}

/* Bento Grid System */
.por-bento-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  z-index: 2;
  position: relative;
}

.por-bento-card {
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 24px;
  padding: 32px;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
}

.por-bento-card:hover {
  transform: translateY(-4px);
  border-color: rgb(87 87 101 / 35%);
  box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.5), 0 0 30px rgba(99, 102, 241, 0.08);
}

/* Card-specific column mappings */
.card-hero {
  grid-column: span 2;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6) 0%, rgba(30, 41, 59, 0.3) 100%);
}

.card-gauge {
  grid-column: span 1;
}

.card-verify-portal {
  grid-column: span 2;
}

.card-downloads {
  grid-column: span 1;
}

.card-full {
  grid-column: span 3;
}

/* Status Badge */
.por-status-badge {
  background: #e2caa030;
  border: 1px solid #E2CAA0;
  border-radius: 50px;
  padding: 6px 14px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  background-color: #d1aa67;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 0 0 rgba(29, 29, 29, 0.7);
  animation: pulse-ring 1.8s infinite;
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(169, 140, 10, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

.por-badge-text {
  font-size: 12px;
  font-weight: 600;
  color: #d1aa67;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

/* Titles and subtext */
.por-main-title {
  font-size: 2.85rem;
  font-weight: 800;
  letter-spacing: -1.5px;
  line-height: 1.15;
  margin-bottom: 1rem;
}

.text-gradient {
  background: linear-gradient(135deg, #ffffff 20%, #d1aa67 50%, #d1aa67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.por-subtitle {
  color: #94a3b8;
  font-size: 1.05rem;
  line-height: 1.6;
  max-width: 600px;
}

.por-feat-badge {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 6px 12px;
  color: #cbd5e1;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Gauge Circle Graph */
.por-svg-gauge-container {
  position: relative;
  width: 160px;
  height: 160px;
}

.por-circle-gauge {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.gauge-bg-circle {
  fill: none;
  stroke: rgba(255, 255, 255, 0.05);
  stroke-width: 10;
}

.gauge-val-circle {
  fill: none;
  stroke: url(#gauge-gradient);
  stroke: #696969;
  /* Fallback */
  stroke-width: 10;
  stroke-linecap: round;
  stroke-dasharray: 314;
  animation: stroke-anim 1.5s ease-out forwards;
}

/* Linear Gradient definition for SVG */
.por-circle-gauge {
  background-color: #161826;
  border-radius: 50%;
  box-shadow: inset 0 0 20px rgb(0 0 0 / 14%);
}

body.light_theme .por-circle-gauge {
  background-color: #ffffff;
}

@keyframes stroke-anim {
  from {
    stroke-dashoffset: 314;
  }
}

.por-gauge-text-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.ratio-pct {
  font-size: 1.6rem;
  font-weight: 800;
  color: #ffffff;
  font-family: 'Outfit', sans-serif;
}

.ratio-lbl {
  font-size: 10px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.font-outfit {
  font-family: 'Outfit', sans-serif;
}

.stat-lbl {
  font-size: 11px;
}

.stat-val {
  font-size: 14px;
}

/* Verification Pill Buttons */
.por-btn-group-pill {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50px;
  padding: 4px;
  display: flex;
}

.pill-tab-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.pill-tab-btn.active {
  background: #d1aa67;
  color: #ffffff;
}

/* Form inputs & verify portal */
body form.por-verify-form .por-form-input {
  background-color: #0b0f19 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  color: #ffffff !important;
  border-radius: 12px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
}

body.light_theme form.por-verify-form .por-form-input {
  background-color: #f7f7f7 !important;
  color: #0b0f19 !important;
}

body.light_theme form.por-verify-form .input-group {
  background-color: #f7f7f7 !important;
  border-radius: 12px;
}

body form.por-verify-form .input-group .por-form-input {
  border-left: 0px !important;
  border-radius: 0px 12px 12px 0px !important;
}

body .por-input-addon {
  min-width: auto;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  color: #64748b !important;
  border-top-left-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.por-verify-btn {
  background: #d1aa67;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  border-radius: 12px !important;
  transition: transform 0.2s ease !important;
}

.por-verify-btn:hover {
  background: #c5a05f;
  transform: translateY(-2px);
}

/* Verifier states */
.por-verifier-empty-state {
  background: rgba(15, 23, 42, 0.25);
  border: 1px dashed rgba(255, 255, 255, 0.08);
  border-radius: 16px;
}

.por-interactive-merkle-flow {
  background: rgba(15, 23, 42, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.tech-icon-wrap {
  width: 40px;
  height: 40px;
  background: rgba(99, 102, 241, 0.1);
  color: #818cf8;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.por-warning-banner {
  background: rgba(245, 158, 11, 0.05);
  border: 1px solid rgba(245, 158, 11, 0.1);
}

/* Merkle Tree Nodes in Bento Grid */
.por-tree-flow {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.por-tree-node {
  background: rgba(15, 23, 42, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 10px 16px;
  text-align: center;
  width: 100%;
  max-width: 320px;
}

.por-tree-node.root {
  border-color: rgba(245, 158, 11, 0.5);
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.9) 0%, rgba(245, 158, 11, 0.05) 100%);
}

.por-tree-node.branch {
  border-color: rgba(99, 102, 241, 0.4);
}

.por-tree-node.leaf.active {
  border-color: rgba(16, 185, 129, 0.5);
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.9) 0%, rgba(16, 185, 129, 0.05) 100%);
}

.por-tree-node.leaf.sibling {
  border-color: rgba(148, 163, 184, 0.25);
  opacity: 0.75;
}

.por-tree-connector {
  width: 2px;
  height: 16px;
  background-color: rgba(255, 255, 255, 0.1);
}

.node-badge {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 1px 6px;
  border-radius: 4px;
  display: inline-block;
}

.root-badge {
  background: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
}

.branch-badge {
  background: rgba(99, 102, 241, 0.15);
  color: #818cf8;
}

.leaf-badge {
  background: rgba(16, 185, 129, 0.15);
  color: #34d399;
}

.sibling-badge {
  background: rgba(255, 255, 255, 0.05);
  color: #94a3b8;
}

.node-hash {
  font-size: 11px;
  color: #94a3b8;
  word-break: break-all;
  font-family: monospace;
}

/* Bento download buttons */
.por-bento-download-btn {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  color: #cbd5e1 !important;
  border-radius: 14px !important;
  padding: 14px 20px !important;
  width: 100% !important;
  transition: all 0.2s ease !important;
}

.por-bento-download-btn:hover {
  background: rgba(99, 102, 241, 0.08) !important;
  border-color: rgba(99, 102, 241, 0.3) !important;
  color: #ffffff !important;
}

.por-bento-download-btn .btn-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
  font-size: 14px;
}

/* Asset table search */
.por-table-search-box {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.por-table-search-box input {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 13px;
  outline: none;
}

.por-table-search-box .search-icon {
  color: #64748b;
}

/* Bento grid breakdown table styles */
.por-bento-table {
  background-color: transparent !important;
}

.por-bento-table th {
  background-color: rgba(0, 0, 0, 0.1) !important;
  color: #64748b !important;
  border-bottom: 2px solid rgba(255, 255, 255, 0.08) !important;
  font-size: 13px;
  font-weight: 600;
  padding: 16px 20px;
}

.por-bento-table td {
  background-color: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;
  padding: 18px 20px;
}

.por-bento-table tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.02) !important;
}

.por-table-coin-icon {
  width: 32px;
  height: 32px;
}

.por-table-progress {
  background-color: rgba(255, 255, 255, 0.06) !important;
}

.por-status-indicator {
  background-color: rgba(16, 185, 129, 0.08);
  color: #34d399;
  border: 1px solid rgba(16, 185, 129, 0.15);
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 6px;
}

/* Accordion FAQs */
.por-faq-item-bento button:hover .question-text {
  color: #ffffff !important;
}



.por-faq-item-bento button span {
  font-size: 15px;
}

.por-faq-item-bento .answer-text {
  line-height: 1.7;
}

/* ==========================================================
   LIGHT THEME OVERRIDES (.light_theme toggle)
   ========================================================== */

body.light_theme .por-page-container {
  background-color: #f8fafc;
  color: #0f172a;
}

body.light_theme .por-mesh-grid {
  background-image:
    radial-gradient(rgba(99, 102, 241, 0.07) 1px, transparent 1px),
    radial-gradient(rgba(245, 158, 11, 0.05) 1px, transparent 1px);
  opacity: 0.9;
}

body.light_theme .por-radial-spot {
  opacity: 0.06;
}

/* Light theme bento cards */
body.light_theme .por-bento-card {
  background: rgb(255 255 255 / 20%);
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 10px 30px -10px rgba(15, 23, 42, 0.08);
}

body.light_theme .por-bento-card:hover {
  border-color: rgb(176 176 176 / 40%);
  box-shadow: 0 20px 40px -15px rgba(15, 23, 42, 0.12);
}

body.light_theme .card-hero {
  background: linear-gradient(135deg, #ffffff 0%, rgba(241, 245, 249, 0.6) 100%);
}

/* Light text */
body.light_theme .text-gradient {
  background: linear-gradient(135deg, #000000 30%, #d1aa67 80%, #d1aa67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

body.light_theme .por-subtitle {
  color: #475569;
}

body.light_theme .por-panel-title {
  color: #0f172a !important;
}

body.light_theme .por-feat-badge {
  background: rgba(15, 23, 42, 0.03);
  border: 1px solid rgba(15, 23, 42, 0.06);
  color: #334155;
}

body.light_theme .text-white {
  color: #0f172a !important;
}

body.light_theme .text-muted {
  color: #64748b !important;
}

/* Light theme gauge */
body.light_theme .gauge-bg-circle {
  stroke: rgba(15, 23, 42, 0.05);
}

body.light_theme .ratio-pct {
  color: #0f172a;
}

body.light_theme .ratio-lbl {
  color: #64748b;
}

body.light_theme .por-gauge-text-overlay {
  text-shadow: none;
}

/* Verifier & Tab Pill indicators */
body.light_theme .por-btn-group-pill {
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.08);
}

body.light_theme .pill-tab-btn {
  color: #64748b;
}

body.light_theme .pill-tab-btn.active {
  background: #d1aa67;
  color: #ffffff;
}

/* Light theme inputs */
body.light_theme .por-form-input {
  background-color: #ffffff !important;
  border: 1px solid rgba(15, 23, 42, 0.15) !important;
  color: #0f172a !important;
  border-left: none !important;
}

body.light_theme .por-form-input:focus {
  border-color: #6366f1 !important;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;
}

/* Nodes and Merkle flow in Light theme */
body.light_theme .por-verifier-empty-state {
  background: rgba(15, 23, 42, 0.02);
  border: 1px dashed rgba(15, 23, 42, 0.1);
}

body.light_theme .por-interactive-merkle-flow {
  background: rgba(15, 23, 42, 0.02);
  border: 1px solid rgba(15, 23, 42, 0.06);
}

body.light_theme .por-tree-node {
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
}

body.light_theme .por-tree-node.root {
  border-color: rgba(245, 158, 11, 0.4);
  background: linear-gradient(180deg, #ffffff 0%, rgba(245, 158, 11, 0.04) 100%);
}

body.light_theme .por-tree-node.leaf.active {
  border-color: rgba(16, 185, 129, 0.4);
  background: linear-gradient(180deg, #ffffff 0%, rgba(16, 185, 129, 0.04) 100%);
}

body.light_theme .por-tree-node.leaf.sibling {
  border-color: rgba(15, 23, 42, 0.08);
}

body.light_theme .node-hash {
  color: #475569;
}

body.light_theme .por-tree-connector {
  background-color: rgba(15, 23, 42, 0.1);
}

body.light_theme .tech-icon-wrap {
  background: rgba(99, 102, 241, 0.06);
}

body.light_theme .por-warning-banner {
  background: rgba(245, 158, 11, 0.04);
  border-color: rgba(245, 158, 11, 0.08);
}

/* Downloads & buttons in light theme */
body.light_theme .por-bento-download-btn {
  background: rgba(15, 23, 42, 0.03) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  color: #334155 !important;
}

body.light_theme .por-bento-download-btn:hover {
  background: rgba(99, 102, 241, 0.06) !important;
  border-color: rgba(99, 102, 241, 0.25) !important;
  color: #4f46e5 !important;
}

/* Table light overrides */
body.light_theme .por-table-search-box {
  background: rgba(15, 23, 42, 0.03);
  border: 1px solid rgba(15, 23, 42, 0.08);
}

body.light_theme .por-table-search-box input {
  color: #0f172a;
}

body.light_theme .por-bento-table th {
  background-color: rgba(15, 23, 42, 0.02) !important;
  color: #475569 !important;
  border-bottom: 2px solid rgba(15, 23, 42, 0.08) !important;
}

body.light_theme .por-bento-table td {
  border-bottom: 1px solid rgba(15, 23, 42, 0.05) !important;
  color: #334155;
}

body.light_theme .por-bento-table tbody tr:hover {
  background-color: rgba(15, 23, 42, 0.01) !important;
}

body.light_theme .por-table-progress {
  background-color: rgba(15, 23, 42, 0.05) !important;
}

/* FAQ item light overrides */
body.light_theme .por-faq-item-bento {
  border-bottom-color: rgba(15, 23, 42, 0.06) !important;
}

body.light_theme .por-faq-item-bento button:hover .question-text {
  color: #000000 !important;
}

/* ==========================================================
   RESPONSIVE LAYOUT FIXES
   ========================================================== */

@media (max-width: 1024px) {
  .por-bento-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .card-hero {
    grid-column: span 2;
  }

  .card-gauge {
    grid-column: span 2;
  }

  .card-verify-portal {
    grid-column: span 2;
  }

  .card-downloads {
    grid-column: span 2;
  }

  .card-full {
    grid-column: span 2;
  }
}

@media (max-width: 768px) {

  .por-bento-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .card-hero,
  .card-gauge,
  .card-verify-portal,
  .card-downloads,
  .card-full {
    grid-column: revert-rule;
  }

  .por-main-title {
    font-size: 30px;
    letter-spacing: 0px;
  }

  .por-bento-card {
    padding: 24px;
  }
}


@media (max-width: 767px) {

  .por-main-title {
    font-size: 24px;
  }

  .por-subtitle {
    font-size: 14px;
  }

  .por-hero-features-row {
    gap: 15px !important;
    margin-top: 10px !important;
  }

  .por-verify-btn {
    padding: 9px 12px !important;
    font-size: 14px;
    border-radius: 8px !important;
  }

}


.por-faq-item-bento svg.text-primary {
  color: #ffffff !important;
}

body.light_theme .por-faq-item-bento svg.text-primary {
  color: #242424 !important;
}

.por-faq-item-bento .small {
  font-size: 14px;
}

h3.por-panel-title.text-white {
  text-align: left !important;
}

/* Responsive mobile layout for Reserve breakdown */
.por-desktop-table-wrapper {
  display: block;
}

.por-mobile-cards-wrapper {
  display: none;
}

.por-mobile-asset-card {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.por-mobile-asset-card:hover {
  transform: translateY(-2px);
  border-color: rgba(209, 170, 103, 0.3);
}

.por-mobile-asset-card .card-details-row {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.por-mobile-asset-card .stat-lbl {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 4px;
}

.por-mobile-asset-card .stat-val {
  font-size: 13px;
  font-weight: 600;
}

/* Light Theme overrides for mobile asset card */
body.light_theme .por-mobile-asset-card {
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
}

body.light_theme .por-mobile-asset-card:hover {
  border-color: rgba(209, 170, 103, 0.4);
}

body.light_theme .por-mobile-asset-card .card-details-row {
  border-top: 1px solid rgba(15, 23, 42, 0.06);
}

body.light_theme .por-mobile-asset-card .coin-name {
  color: #0f172a !important;
}

body.light_theme .por-mobile-asset-card .stat-val {
  color: #0f172a !important;
}

@media (max-width: 767px) {
  .por-desktop-table-wrapper {
    display: none;
  }

  .por-mobile-cards-wrapper {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ProofOfReserves/proof-reserves.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC,gDAAgD;AAChD;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;kEAEgE;EAChE,0BAA0B;EAC1B,mCAAmC;EACnC,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,0EAA0E;EAC1E,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0EAA0E;EAC1E,UAAU;EACV,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,sGAAsG;EACtG,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,mFAAmF;AACrF;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yFAAyF;AAC3F;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE;IACE,sBAAsB;IACtB,2CAA2C;EAC7C;;EAEA;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,sDAAsD;EACtD,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,sDAAsD;EACtD,yBAAyB;EACzB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,4FAA4F;AAC9F;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,4FAA4F;AAC9F;;AAEA;EACE,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,gDAAgD;EAChD,sDAAsD;EACtD,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;+DAE+D;;AAE/D;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;;kEAEgE;EAChE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;EAClC,wCAAwC;EACxC,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,8EAA8E;AAChF;;AAEA,eAAe;AACf;EACE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,mDAAmD;EACnD,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA,yCAAyC;AACzC;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;EACrC,8EAA8E;AAChF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,uCAAuC;AACvC;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA,6BAA6B;AAC7B;EACE,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;+DAE+D;;AAE/D;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;EAC/B;;AAEF;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Bento Grid Proof of Reserves CSS */\n\n/* Base container with dynamic grid background */\n.por-page-container {\n  background-color: #030712;\n  color: #f8fafc;\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Inter', 'Outfit', sans-serif;\n  z-index: 1;\n}\n\n/* Premium mesh grid pattern overlay */\n.por-mesh-grid {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image:\n    radial-gradient(rgba(99, 102, 241, 0.05) 1px, transparent 1px),\n    radial-gradient(rgba(245, 158, 11, 0.03) 1px, transparent 1px);\n  background-size: 40px 40px;\n  background-position: 0 0, 20px 20px;\n  opacity: 0.8;\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* Ambient glow lights */\n.por-radial-spot {\n  position: absolute;\n  width: 600px;\n  height: 600px;\n  border-radius: 50%;\n  filter: blur(140px);\n  pointer-events: none;\n  opacity: 0.12;\n  z-index: 0;\n}\n\n.por-spot-indigo {\n  background: radial-gradient(circle, #6366f1 0%, rgba(99, 102, 241, 0) 70%);\n  top: -150px;\n  right: -50px;\n}\n\n.por-spot-amber {\n  background: radial-gradient(circle, #f59e0b 0%, rgba(245, 158, 11, 0) 70%);\n  bottom: 5%;\n  left: -200px;\n}\n\n/* Bento Grid System */\n.por-bento-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  z-index: 2;\n  position: relative;\n}\n\n.por-bento-card {\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 24px;\n  padding: 32px;\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);\n}\n\n.por-bento-card:hover {\n  transform: translateY(-4px);\n  border-color: rgb(87 87 101 / 35%);\n  box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.5), 0 0 30px rgba(99, 102, 241, 0.08);\n}\n\n/* Card-specific column mappings */\n.card-hero {\n  grid-column: span 2;\n  background: linear-gradient(135deg, rgba(15, 23, 42, 0.6) 0%, rgba(30, 41, 59, 0.3) 100%);\n}\n\n.card-gauge {\n  grid-column: span 1;\n}\n\n.card-verify-portal {\n  grid-column: span 2;\n}\n\n.card-downloads {\n  grid-column: span 1;\n}\n\n.card-full {\n  grid-column: span 3;\n}\n\n/* Status Badge */\n.por-status-badge {\n  background: #e2caa030;\n  border: 1px solid #E2CAA0;\n  border-radius: 50px;\n  padding: 6px 14px;\n}\n\n.pulse-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #d1aa67;\n  border-radius: 50%;\n  display: inline-block;\n  box-shadow: 0 0 0 0 rgba(29, 29, 29, 0.7);\n  animation: pulse-ring 1.8s infinite;\n}\n\n@keyframes pulse-ring {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(169, 140, 10, 0.7);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n  }\n}\n\n.por-badge-text {\n  font-size: 12px;\n  font-weight: 600;\n  color: #d1aa67;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n}\n\n/* Titles and subtext */\n.por-main-title {\n  font-size: 2.85rem;\n  font-weight: 800;\n  letter-spacing: -1.5px;\n  line-height: 1.15;\n  margin-bottom: 1rem;\n}\n\n.text-gradient {\n  background: linear-gradient(135deg, #ffffff 20%, #d1aa67 50%, #d1aa67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.por-subtitle {\n  color: #94a3b8;\n  font-size: 1.05rem;\n  line-height: 1.6;\n  max-width: 600px;\n}\n\n.por-feat-badge {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 6px 12px;\n  color: #cbd5e1;\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Gauge Circle Graph */\n.por-svg-gauge-container {\n  position: relative;\n  width: 160px;\n  height: 160px;\n}\n\n.por-circle-gauge {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.gauge-bg-circle {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.05);\n  stroke-width: 10;\n}\n\n.gauge-val-circle {\n  fill: none;\n  stroke: url(#gauge-gradient);\n  stroke: #696969;\n  /* Fallback */\n  stroke-width: 10;\n  stroke-linecap: round;\n  stroke-dasharray: 314;\n  animation: stroke-anim 1.5s ease-out forwards;\n}\n\n/* Linear Gradient definition for SVG */\n.por-circle-gauge {\n  background-color: #161826;\n  border-radius: 50%;\n  box-shadow: inset 0 0 20px rgb(0 0 0 / 14%);\n}\n\nbody.light_theme .por-circle-gauge {\n  background-color: #ffffff;\n}\n\n@keyframes stroke-anim {\n  from {\n    stroke-dashoffset: 314;\n  }\n}\n\n.por-gauge-text-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\n}\n\n.ratio-pct {\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: #ffffff;\n  font-family: 'Outfit', sans-serif;\n}\n\n.ratio-lbl {\n  font-size: 10px;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.font-outfit {\n  font-family: 'Outfit', sans-serif;\n}\n\n.stat-lbl {\n  font-size: 11px;\n}\n\n.stat-val {\n  font-size: 14px;\n}\n\n/* Verification Pill Buttons */\n.por-btn-group-pill {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 50px;\n  padding: 4px;\n  display: flex;\n}\n\n.pill-tab-btn {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  padding: 6px 16px;\n  border-radius: 50px;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.pill-tab-btn.active {\n  background: #d1aa67;\n  color: #ffffff;\n}\n\n/* Form inputs & verify portal */\nbody form.por-verify-form .por-form-input {\n  background-color: #0b0f19 !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  color: #ffffff !important;\n  border-radius: 12px !important;\n  padding: 10px 14px !important;\n  font-size: 14px !important;\n}\n\nbody.light_theme form.por-verify-form .por-form-input {\n  background-color: #f7f7f7 !important;\n  color: #0b0f19 !important;\n}\n\nbody.light_theme form.por-verify-form .input-group {\n  background-color: #f7f7f7 !important;\n  border-radius: 12px;\n}\n\nbody form.por-verify-form .input-group .por-form-input {\n  border-left: 0px !important;\n  border-radius: 0px 12px 12px 0px !important;\n}\n\nbody .por-input-addon {\n  min-width: auto;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  color: #64748b !important;\n  border-top-left-radius: 12px !important;\n  border-bottom-left-radius: 12px !important;\n}\n\n.por-verify-btn {\n  background: #d1aa67;\n  border: none !important;\n  color: white !important;\n  font-weight: 600 !important;\n  border-radius: 12px !important;\n  transition: transform 0.2s ease !important;\n}\n\n.por-verify-btn:hover {\n  background: #c5a05f;\n  transform: translateY(-2px);\n}\n\n/* Verifier states */\n.por-verifier-empty-state {\n  background: rgba(15, 23, 42, 0.25);\n  border: 1px dashed rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n}\n\n.por-interactive-merkle-flow {\n  background: rgba(15, 23, 42, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.tech-icon-wrap {\n  width: 40px;\n  height: 40px;\n  background: rgba(99, 102, 241, 0.1);\n  color: #818cf8;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.por-warning-banner {\n  background: rgba(245, 158, 11, 0.05);\n  border: 1px solid rgba(245, 158, 11, 0.1);\n}\n\n/* Merkle Tree Nodes in Bento Grid */\n.por-tree-flow {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.por-tree-node {\n  background: rgba(15, 23, 42, 0.85);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 10px 16px;\n  text-align: center;\n  width: 100%;\n  max-width: 320px;\n}\n\n.por-tree-node.root {\n  border-color: rgba(245, 158, 11, 0.5);\n  background: linear-gradient(180deg, rgba(15, 23, 42, 0.9) 0%, rgba(245, 158, 11, 0.05) 100%);\n}\n\n.por-tree-node.branch {\n  border-color: rgba(99, 102, 241, 0.4);\n}\n\n.por-tree-node.leaf.active {\n  border-color: rgba(16, 185, 129, 0.5);\n  background: linear-gradient(180deg, rgba(15, 23, 42, 0.9) 0%, rgba(16, 185, 129, 0.05) 100%);\n}\n\n.por-tree-node.leaf.sibling {\n  border-color: rgba(148, 163, 184, 0.25);\n  opacity: 0.75;\n}\n\n.por-tree-connector {\n  width: 2px;\n  height: 16px;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.node-badge {\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 1px 6px;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.root-badge {\n  background: rgba(245, 158, 11, 0.15);\n  color: #f59e0b;\n}\n\n.branch-badge {\n  background: rgba(99, 102, 241, 0.15);\n  color: #818cf8;\n}\n\n.leaf-badge {\n  background: rgba(16, 185, 129, 0.15);\n  color: #34d399;\n}\n\n.sibling-badge {\n  background: rgba(255, 255, 255, 0.05);\n  color: #94a3b8;\n}\n\n.node-hash {\n  font-size: 11px;\n  color: #94a3b8;\n  word-break: break-all;\n  font-family: monospace;\n}\n\n/* Bento download buttons */\n.por-bento-download-btn {\n  background: rgba(255, 255, 255, 0.03) !important;\n  border: 1px solid rgba(255, 255, 255, 0.06) !important;\n  color: #cbd5e1 !important;\n  border-radius: 14px !important;\n  padding: 14px 20px !important;\n  width: 100% !important;\n  transition: all 0.2s ease !important;\n}\n\n.por-bento-download-btn:hover {\n  background: rgba(99, 102, 241, 0.08) !important;\n  border-color: rgba(99, 102, 241, 0.3) !important;\n  color: #ffffff !important;\n}\n\n.por-bento-download-btn .btn-inner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* Asset table search */\n.por-table-search-box {\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 8px 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.por-table-search-box input {\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 13px;\n  outline: none;\n}\n\n.por-table-search-box .search-icon {\n  color: #64748b;\n}\n\n/* Bento grid breakdown table styles */\n.por-bento-table {\n  background-color: transparent !important;\n}\n\n.por-bento-table th {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n  color: #64748b !important;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.08) !important;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 16px 20px;\n}\n\n.por-bento-table td {\n  background-color: transparent !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;\n  padding: 18px 20px;\n}\n\n.por-bento-table tbody tr:hover {\n  background-color: rgba(255, 255, 255, 0.02) !important;\n}\n\n.por-table-coin-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.por-table-progress {\n  background-color: rgba(255, 255, 255, 0.06) !important;\n}\n\n.por-status-indicator {\n  background-color: rgba(16, 185, 129, 0.08);\n  color: #34d399;\n  border: 1px solid rgba(16, 185, 129, 0.15);\n  padding: 4px 10px;\n  font-size: 12px;\n  border-radius: 6px;\n}\n\n/* Accordion FAQs */\n.por-faq-item-bento button:hover .question-text {\n  color: #ffffff !important;\n}\n\n\n\n.por-faq-item-bento button span {\n  font-size: 15px;\n}\n\n.por-faq-item-bento .answer-text {\n  line-height: 1.7;\n}\n\n/* ==========================================================\n   LIGHT THEME OVERRIDES (.light_theme toggle)\n   ========================================================== */\n\nbody.light_theme .por-page-container {\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\nbody.light_theme .por-mesh-grid {\n  background-image:\n    radial-gradient(rgba(99, 102, 241, 0.07) 1px, transparent 1px),\n    radial-gradient(rgba(245, 158, 11, 0.05) 1px, transparent 1px);\n  opacity: 0.9;\n}\n\nbody.light_theme .por-radial-spot {\n  opacity: 0.06;\n}\n\n/* Light theme bento cards */\nbody.light_theme .por-bento-card {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  box-shadow: 0 10px 30px -10px rgba(15, 23, 42, 0.08);\n}\n\nbody.light_theme .por-bento-card:hover {\n  border-color: rgb(176 176 176 / 40%);\n  box-shadow: 0 20px 40px -15px rgba(15, 23, 42, 0.12);\n}\n\nbody.light_theme .card-hero {\n  background: linear-gradient(135deg, #ffffff 0%, rgba(241, 245, 249, 0.6) 100%);\n}\n\n/* Light text */\nbody.light_theme .text-gradient {\n  background: linear-gradient(135deg, #000000 30%, #d1aa67 80%, #d1aa67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\nbody.light_theme .por-subtitle {\n  color: #475569;\n}\n\nbody.light_theme .por-panel-title {\n  color: #0f172a !important;\n}\n\nbody.light_theme .por-feat-badge {\n  background: rgba(15, 23, 42, 0.03);\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  color: #334155;\n}\n\nbody.light_theme .text-white {\n  color: #0f172a !important;\n}\n\nbody.light_theme .text-muted {\n  color: #64748b !important;\n}\n\n/* Light theme gauge */\nbody.light_theme .gauge-bg-circle {\n  stroke: rgba(15, 23, 42, 0.05);\n}\n\nbody.light_theme .ratio-pct {\n  color: #0f172a;\n}\n\nbody.light_theme .ratio-lbl {\n  color: #64748b;\n}\n\nbody.light_theme .por-gauge-text-overlay {\n  text-shadow: none;\n}\n\n/* Verifier & Tab Pill indicators */\nbody.light_theme .por-btn-group-pill {\n  background: rgba(15, 23, 42, 0.04);\n  border: 1px solid rgba(15, 23, 42, 0.08);\n}\n\nbody.light_theme .pill-tab-btn {\n  color: #64748b;\n}\n\nbody.light_theme .pill-tab-btn.active {\n  background: #d1aa67;\n  color: #ffffff;\n}\n\n/* Light theme inputs */\nbody.light_theme .por-form-input {\n  background-color: #ffffff !important;\n  border: 1px solid rgba(15, 23, 42, 0.15) !important;\n  color: #0f172a !important;\n  border-left: none !important;\n}\n\nbody.light_theme .por-form-input:focus {\n  border-color: #6366f1 !important;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;\n}\n\n/* Nodes and Merkle flow in Light theme */\nbody.light_theme .por-verifier-empty-state {\n  background: rgba(15, 23, 42, 0.02);\n  border: 1px dashed rgba(15, 23, 42, 0.1);\n}\n\nbody.light_theme .por-interactive-merkle-flow {\n  background: rgba(15, 23, 42, 0.02);\n  border: 1px solid rgba(15, 23, 42, 0.06);\n}\n\nbody.light_theme .por-tree-node {\n  background: #ffffff;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);\n}\n\nbody.light_theme .por-tree-node.root {\n  border-color: rgba(245, 158, 11, 0.4);\n  background: linear-gradient(180deg, #ffffff 0%, rgba(245, 158, 11, 0.04) 100%);\n}\n\nbody.light_theme .por-tree-node.leaf.active {\n  border-color: rgba(16, 185, 129, 0.4);\n  background: linear-gradient(180deg, #ffffff 0%, rgba(16, 185, 129, 0.04) 100%);\n}\n\nbody.light_theme .por-tree-node.leaf.sibling {\n  border-color: rgba(15, 23, 42, 0.08);\n}\n\nbody.light_theme .node-hash {\n  color: #475569;\n}\n\nbody.light_theme .por-tree-connector {\n  background-color: rgba(15, 23, 42, 0.1);\n}\n\nbody.light_theme .tech-icon-wrap {\n  background: rgba(99, 102, 241, 0.06);\n}\n\nbody.light_theme .por-warning-banner {\n  background: rgba(245, 158, 11, 0.04);\n  border-color: rgba(245, 158, 11, 0.08);\n}\n\n/* Downloads & buttons in light theme */\nbody.light_theme .por-bento-download-btn {\n  background: rgba(15, 23, 42, 0.03) !important;\n  border: 1px solid rgba(15, 23, 42, 0.08) !important;\n  color: #334155 !important;\n}\n\nbody.light_theme .por-bento-download-btn:hover {\n  background: rgba(99, 102, 241, 0.06) !important;\n  border-color: rgba(99, 102, 241, 0.25) !important;\n  color: #4f46e5 !important;\n}\n\n/* Table light overrides */\nbody.light_theme .por-table-search-box {\n  background: rgba(15, 23, 42, 0.03);\n  border: 1px solid rgba(15, 23, 42, 0.08);\n}\n\nbody.light_theme .por-table-search-box input {\n  color: #0f172a;\n}\n\nbody.light_theme .por-bento-table th {\n  background-color: rgba(15, 23, 42, 0.02) !important;\n  color: #475569 !important;\n  border-bottom: 2px solid rgba(15, 23, 42, 0.08) !important;\n}\n\nbody.light_theme .por-bento-table td {\n  border-bottom: 1px solid rgba(15, 23, 42, 0.05) !important;\n  color: #334155;\n}\n\nbody.light_theme .por-bento-table tbody tr:hover {\n  background-color: rgba(15, 23, 42, 0.01) !important;\n}\n\nbody.light_theme .por-table-progress {\n  background-color: rgba(15, 23, 42, 0.05) !important;\n}\n\n/* FAQ item light overrides */\nbody.light_theme .por-faq-item-bento {\n  border-bottom-color: rgba(15, 23, 42, 0.06) !important;\n}\n\nbody.light_theme .por-faq-item-bento button:hover .question-text {\n  color: #000000 !important;\n}\n\n/* ==========================================================\n   RESPONSIVE LAYOUT FIXES\n   ========================================================== */\n\n@media (max-width: 1024px) {\n  .por-bento-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .card-hero {\n    grid-column: span 2;\n  }\n\n  .card-gauge {\n    grid-column: span 2;\n  }\n\n  .card-verify-portal {\n    grid-column: span 2;\n  }\n\n  .card-downloads {\n    grid-column: span 2;\n  }\n\n  .card-full {\n    grid-column: span 2;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .por-bento-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .card-hero,\n  .card-gauge,\n  .card-verify-portal,\n  .card-downloads,\n  .card-full {\n    grid-column: revert-rule;\n  }\n\n  .por-main-title {\n    font-size: 30px;\n    letter-spacing: 0px;\n  }\n\n  .por-bento-card {\n    padding: 24px;\n  }\n}\n\n\n@media (max-width: 767px) {\n\n  .por-main-title {\n    font-size: 24px;\n  }\n\n  .por-subtitle {\n    font-size: 14px;\n  }\n\n  .por-hero-features-row {\n    gap: 15px !important;\n    margin-top: 10px !important;\n  }\n\n  .por-verify-btn {\n    padding: 9px 12px !important;\n    font-size: 14px;\n    border-radius: 8px !important;\n  }\n\n}\n\n\n.por-faq-item-bento svg.text-primary {\n  color: #ffffff !important;\n}\n\nbody.light_theme .por-faq-item-bento svg.text-primary {\n  color: #242424 !important;\n}\n\n.por-faq-item-bento .small {\n  font-size: 14px;\n}\n\nh3.por-panel-title.text-white {\n  text-align: left !important;\n}\n\n/* Responsive mobile layout for Reserve breakdown */\n.por-desktop-table-wrapper {\n  display: block;\n}\n\n.por-mobile-cards-wrapper {\n  display: none;\n}\n\n.por-mobile-asset-card {\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 16px;\n  transition: transform 0.2s ease, border-color 0.2s ease;\n}\n\n.por-mobile-asset-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(209, 170, 103, 0.3);\n}\n\n.por-mobile-asset-card .card-details-row {\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.por-mobile-asset-card .stat-lbl {\n  font-size: 11px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.por-mobile-asset-card .stat-val {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n/* Light Theme overrides for mobile asset card */\nbody.light_theme .por-mobile-asset-card {\n  background: #ffffff;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);\n}\n\nbody.light_theme .por-mobile-asset-card:hover {\n  border-color: rgba(209, 170, 103, 0.4);\n}\n\nbody.light_theme .por-mobile-asset-card .card-details-row {\n  border-top: 1px solid rgba(15, 23, 42, 0.06);\n}\n\nbody.light_theme .por-mobile-asset-card .coin-name {\n  color: #0f172a !important;\n}\n\nbody.light_theme .por-mobile-asset-card .stat-val {\n  color: #0f172a !important;\n}\n\n@media (max-width: 767px) {\n  .por-desktop-table-wrapper {\n    display: none;\n  }\n\n  .por-mobile-cards-wrapper {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
